import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Login from './Pages/Login';

import Home from './Pages/Home';
import Games from './Pages/Games';
import Movies from './Pages/Movies';
import Series from './Pages/Series';
import Books from './Pages/Books';
import AddMovie from './Pages/AddMovie';
import AddGame from './Pages/AddGame';
import AddSeries from './Pages/AddSeries';
import AddBook from './Pages/AddBook';
import TodoGames from './Pages/TodoGames';
import TodoMovies from './Pages/TodoMovies';
import TodoSeries from './Pages/TodoSeries';
import TodoBooks from './Pages/TodoBooks';
import Pokemon from './Pages/Pokemon';
import TodoPokemonGames from './Pages/TodoPokemonGames';
import PokemonGame from './Pages/PokemonGame';
import PokemonShinies from './Pages/PokemonShinies';
import PokemonTypes from './Pages/PokemonTypes';
import ShinyDex from './Pages/ShinyDex';
import Stratego from './Pages/Stratego';
import SoulLink from './Pages/SoulLink';
import SoulLinkGame from './Pages/SoulLinkGame';
import SoulLinkRun from './Pages/SoulLinkRun';
import GOTY from './Pages/GOTY';

const App = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Games" element={<Games />} />
        <Route path="/Movies" element={<Movies />} />
        <Route path="/Series" element={<Series />} />
        <Route path="/Books" element={<Books />} />
        <Route path="/add-movie" element={<AddMovie />} />
        <Route path="/add-game" element={<AddGame />} />
        <Route path="/add-series" element={<AddSeries />} />
        <Route path="/add-book" element={<AddBook />} />
        <Route path="/todo-games" element={<TodoGames />} />
        <Route path="/todo-movies" element={<TodoMovies />} />
        <Route path="/todo-series" element={<TodoSeries />} />
        <Route path="/todo-books" element={<TodoBooks />} />
        <Route path="/stratego" element={<Stratego />} />
        <Route path="/pokemon" element={<Pokemon />} />
        <Route path="/pokemon/todo" element={<TodoPokemonGames />} />
        <Route path="/pokemon/shinies" element={<PokemonShinies />} />
        <Route path="/pokemon/types" element={<PokemonTypes />} />
        <Route path="/pokemon/shinydex" element={<ShinyDex />} />
        <Route path="/pokemon/soullink" element={<SoulLink />} />
        <Route path="/pokemon/soullink/:gameId" element={<SoulLinkGame />} />
        <Route path="/pokemon/soullink/:gameId/:runId" element={<SoulLinkRun />} />
        <Route path="/pokemon/:id" element={<PokemonGame />} />
        <Route path="/goty" element={<GOTY />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
